import React from "react";
import styled from "styled-components/macro";
import { Button, Paper, Typography } from "@material-ui/core";

const Wrapper = styled(Paper)`
  max-width: 620px;
  margin: 64px auto;
  padding: 40px;
  text-align: center;
  border-radius: 24px;
`;

class AppErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    if (process.env.NODE_ENV !== "production") {
      console.error("Unhandled application error", error, info);
    }
  }

  handleRetry = () => {
    this.setState({ hasError: false });
    window.location.reload();
  };

  render() {
    if (!this.state.hasError) {
      return this.props.children;
    }

    return (
      <Wrapper role="alert">
        <Typography variant="h4" gutterBottom>
          No pudimos mostrar esta pantalla
        </Typography>
        <Typography color="textSecondary" paragraph>
          Ocurrió una dificultad inesperada. Puede recargar la pantalla sin
          perder la información que ya fue guardada.
        </Typography>
        <Button color="primary" variant="contained" onClick={this.handleRetry}>
          Recargar pantalla
        </Button>
      </Wrapper>
    );
  }
}

export default AppErrorBoundary;
